import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';
import tokeymanIcon from '../../assets/tokey.jpg';

const AdminDashboard = () => {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    const isAdmin = user?.role === 'admin';

    // ===== 🔥 PERMISSION MAP =====
    let role = (user?.role || '').toLowerCase();

    if (typeof role === 'number') role = String(role);
    if (role === '1') role = 'admin';
    if (role === '2') role = 'user';
    if (role === '3') role = 'student';

    const permissions = {
        admin: {
            canAccessSettings: true
        },
        user: {
            canAccessSettings: false
        },
        student: {
            canAccessSettings: false
        }
    };

    const canAccessSettings = permissions[role]?.canAccessSettings;

    // 🔥 BẢO VỆ DASHBOARD
    useEffect(() => {
        if (!localStorage.getItem('user')) {
            navigate('/login', { replace: true });
        }
    }, [navigate]);

    // 🔥 LOGOUT FIX (QUAN TRỌNG)
    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');

        navigate('/login', { replace: true });
    };

    return (
        <div className="admin-layout">
            <aside className="sidebar">
                <div className="sidebar-brand">
                    <span className="brand-icon">
                        <img 
                            src={tokeymanIcon} 
                            alt="Logo" 
                            style={{ width: '24px', height: '24px', borderRadius: '4px', objectFit: 'cover' }} 
                        />
                    </span> Admin Panel
                </div>

                <nav className="sidebar-nav">
                    <div className="nav-item active">🏠 Overview</div>

                    <div 
                        className="nav-item" 
                        onClick={() => navigate('/admin/add-exam')}
                    >
                        📋 Exam Management
                    </div>

                    <div 
                        className="nav-item" 
                        onClick={() => navigate('/admin/add-questions')}
                    >
                        ❓ Question Bank
                    </div>

                    <div 
                        className="nav-item" 
                        onClick={() => navigate('/admin/questions')}
                    >
                        📚 Exam List
                    </div>

                    <div 
                        className="nav-item"
                        onClick={() => {
                            if (!canAccessSettings) return;
                            navigate('/admin/settings');
                        }}
                        style={{
                            cursor: canAccessSettings ? 'pointer' : 'not-allowed',
                            opacity: canAccessSettings ? 1 : 0.5
                        }}
                    >
                        ✉️ Email Config {!canAccessSettings && '🚫'}
                    </div>

                    <div 
                        className="admin-card" 
                        style={{ 
                            opacity: isAdmin ? 1 : 0.6, 
                            cursor: isAdmin ? 'pointer' : 'not-allowed',
                            position: 'relative'
                        }}
                        onClick={() => isAdmin && navigate('/admin/user-management')}
                    >
                        <div className="card-icon">👥</div>
                        <div className="card-content">
                            <h3>User Management</h3>
                            <p>Create and manage Student/User accounts</p>
                        </div>
    
                        {/* Hiển thị biểu tượng khóa nếu là User thường */}
                        {!isAdmin && (
                            <div style={{ position: 'absolute', top: 10, right: 10, fontSize: '20px' }}>
                                🚫
                            </div>
                        )}
                    </div>

                    <div 
                        className="nav-item logout" 
                        onClick={handleLogout}
                    >
                        ↪️ Sign Out
                    </div>
                </nav>

                <div className="sidebar-footer">
                    <div className="user-info">
                        <div className="user-avatar">🛡️</div>
                        <div>
                            <p className="user-name">{user?.fullname || 'Administrator'}</p>
                            <p className="user-role">Super Admin</p>
                        </div>
                    </div>
                </div>
            </aside>

            <main className="main-content">
                <header className="main-header">
                    <h2>Dashboard Overview</h2>
                    <div className="header-user">
                        Welcome, <strong>{user?.fullname}</strong>
                    </div>
                </header>

                <div className="dashboard-grid">

                    <div 
                        className="card" 
                        onClick={() => navigate('/admin/add-exam')}
                    >
                        <div className="card-icon icon-blue">➕</div>
                        <div className="card-body">
                            <h3>Add New Exam</h3>
                            <p>Create Reading, Listening, or Writing tests</p>
                        </div>
                        <div className="card-arrow">→</div>
                    </div>

                    <div 
                        className="card" 
                        onClick={() => navigate('/admin/add-questions')}
                    >
                        <div className="card-icon icon-green">📝</div>
                        <div className="card-body">
                            <h3>Manage Questions</h3>
                            <p>Edit and organize question database</p>
                        </div>
                        <div className="card-arrow">→</div>
                    </div>
                    
                    <div 
                        className="card" 
                        onClick={() => navigate('/admin/questions')}
                    >
                        <div className="card-icon icon-orange">📚</div>

                        <div className="card-body">
                            <h3>Exam List</h3>
                            <p>View and delete exams by category</p>
                        </div>

                        <div className="card-arrow">→</div>
                    </div>


                    {/* 🔥 FIX CARD EMAIL */}
                    <div 
                        className="card large"
                        onClick={() => {
                            if (!canAccessSettings) return;
                            navigate('/admin/settings');
                        }}
                        style={{
                            cursor: canAccessSettings ? 'pointer' : 'not-allowed',
                            opacity: canAccessSettings ? 1 : 0.6
                        }}
                    >
                        <div className="card-icon icon-purple">✉️</div>
                        <div className="card-body">
                            <h3>Email Configuration</h3>
                            <p>Set the recipient email address for student Writing submissions.</p>
                            <button className="btn-config-trigger">
                                ⚙️ Configure Mail {!canAccessSettings && '🚫'} <span>→</span>
                            </button>
                        </div>
                    </div>

                    <div 
    className={`admin-card ${!isAdmin ? 'disabled-card' : ''}`} 
    onClick={() => isAdmin && navigate('/admin/user-management')}
>
    {/* Khung chứa Icon */}
    <div className="card-icon-wrapper user-management-icon">
        <span>👥</span>
    </div>

    {/* Nội dung chữ */}
    <div className="card-info">
        <h3>User Management</h3>
        <p>Create and manage accounts for Students and Users</p>
    </div>

    {/* Mũi tên điều hướng */}
    <div className="card-arrow">→</div>

    {/* Icon khóa nếu không phải Admin */}
    {!isAdmin && <div className="lock-overlay">🚫</div>}
</div>

                    <div 
                        className="card danger" 
                        onClick={handleLogout}
                    >
                        <div className="card-icon icon-red">🚪</div>
                        <div className="card-body">
                            <h3>Sign Out</h3>
                            <p>Securely exit the system</p>
                        </div>
                        <div className="card-arrow">→</div>
                    </div>

                </div>
            </main>
        </div>
    );
};

export default AdminDashboard;